import { All, OperacionActionTypes } from '../actions/operacion.actions';
import { IAjustes, IOperacion, ICatalogo, IEstatus } from 'app/interfaces/interfaces';

export const initialEstatus: IEstatus = {
    idOperacionEstatus  : null,
    nombre              : null,
    descripcion         : null,
    fechaRegistro       : null
}

export const initialSettings: IAjustes = {
    decimal             : null,
    porcentaje          : null,
    email_minFolios     : null,
    email_comprobantes  : null
}

export const initialCatalogo: ICatalogo = {
    idCatalogo  : null,
    nombre      : null,
    valor       : null
}

export const initialState = {
    empresaSeleccionada:{}
}

// export const initialState: IOperacion = {
//     idOperacion             : null,
//     RFC                     : null,
//     razonSocial             : null,
//     nombreComercial         : null,
//     contactoEmail           : null,
//     contactoTelefono        : null,
//     folioInicio             : null,
//     fechaConfiguracion      : null,
//     estatus                 : initialEstatus,
//     tipoPersona             : initialCatalogo,
//     giro                    : initialCatalogo,
//     regimenFiscal           : initialCatalogo,
//     tamanioEmpresa          : initialCatalogo,    
//     ajustes                 : initialSettings,
// };

export function Reducer(state = initialState, action: All) {
    switch (action.type) {
        case OperacionActionTypes.AsignarOperacion:
            return {
                ...action.payload
            };
        case OperacionActionTypes.EliminaOperacion:
            return null;
        default:
            return state;
    }
}